export const FABRaiseWindowWidthTreshold = 768;
export const FABBottom = 24;
export const FABMiniBottomClosed = 32;
export const FABRaisedBottom = 72;
export const FABMiniRaisedBottomClosed = 80;
export const FABMiniBottomOpen1 = 92;
export const FABMiniBottomOpenDiff = 50;
export const FABRight = 24;
export const FABMiniRight = 32;

export const navMiniWidth = 56;
export const navExpandedWidth = 200;

export const transitionEnterTimeout = 170;
export const transitionLeaveTimeout = 150;




// WEBPACK FOOTER //
// ./src/lib/constants.js